import { SVGICON } from "../../constant/theme";
import { useStateContext } from "../../../context/ContextProvider.js";
import { Link } from "react-router-dom";

export const MenuList = [
    // Dashboard
    {
        title: 'الصفحة الرئيسية',
        iconStyle: SVGICON.Home,
        to: '/Dashboard_1',
        permission: 'Dashboard_1'
    },
    {
        title: 'الزبائن ',
        iconStyle: <i className="fa-solid fa-users-line"></i>,
        to: '/Customers',
        permission: 'Customers'
    },
    {
        title: ' الفنين  ',
        iconStyle: <i className="fa-solid fa-users-gear"></i>,
                to: '/Empolyee',
                permission: 'Empolyee'
    },
    {
        title: 'عمليات الصيانه',
        classsChange: 'mm-collapse',
        permission: 'OrdersList',

        iconStyle: <i className="fa-solid fa-screwdriver-wrench"></i>,
        content: [
            {
                title: 'كل عمليات الصيانه',
                iconStyle: <i className="fa-brands fa-shopify"></i>,
                to: '/OrdersList',
                permission: 'OrdersList'
            },
            // {
            //     title: ' طلب صيانه جديد',
            //     to: '/city',
            //     permission: 'city'
            // },
            // {
            //     title: '  ملف الزبون',
            //     iconStyle: <i className="fa-brands fa-shopify"></i>,
            //     to: '/NotConfirmedOrder',
            //     permission: 'NotConfirmedOrder'
            // },
            // {
            //     title: '   ملف السيارة',
            //     to: '/car',
            //     permission: 'First'
            // },
            
        ]
    },
   // {
      //  title: 'اطباق التذوق',
      //  iconStyle: <i className="fa-solid fa-city"></i>,
      //  to: '/Atbak',
      //  permission: 'Atbak'
   // },
   {
    title: 'الخدمات',
    iconStyle: <i className=" fa-solid fa-briefcase"></i>,

    to: '/guaranteetype',
    permission: 'Garantees'
},
    {
        title: 'قطع الغيار',
        iconStyle: <i class="fa-solid fa-car-battery"></i>,
        to: '/Parts',
        permission: 'WeddingHall'
    },
  //  {
  //      title: 'الاصناف',
  //      iconStyle: <i className="fa-solid fa-sitemap"></i>,
   //     to: '/Al-asnaf',
   //     permission: 'Al-asnaf'
   // },
    {
        title: 'الموريدين',
        iconStyle: <i className="fa-solid fa-solid fa-store"></i>,
        to: '/Suppliers',
        permission: 'Tools'
    },
    {
        title: 'المشتريات',
        iconStyle: <i className="fa-solid fa-cart-shopping"></i>,
        to: '/CompanyPurchases',
        permission: 'CompanyPurchases'
    },
    {
        title: 'الشركة',
        classsChange: 'mm-collapse',
        permission: 'MainCompany'
,
        iconStyle: <i className="fa-solid fa-building-circle-exclamation"></i>,
        content: [
            {
                title: 'بيانات الشركة الرئيسية',
                to: '/MainCompany',
                permission: 'MainCompany'
            },
             {
                title: 'مصاريف الانشاء',
                to: '/ConstructionExpensesPage',
                permission: 'ConstructionExpensesPage'
            },
{
                title: 'سجل المستخدمين',
                to: '/UserLog',
                permission: 'UserLog'
            },

            // {
            //     title: 'ارباح الشركة',
            //     to: '/ProfitPage',
            //     permission: 'First'
            // },
            // {
            //     title: 'إحصائيات الشركة',
            //     to: '/First',
            //     permission: 'First'
            // },
            // {
            //     title: 'دخل الشركة',
            //     to: '/Income',
            //     permission: 'Income'
            // },
            {
                title: 'مصروفات الشركة',
                to: '/CompanyExpenses',
                permission: 'CompanyExpenses'
            },
          
           
        ]
    },
    {
    title: 'المحاسبة',
    classsChange: 'mm-collapse',
    permission: 'FixedAssetsPage',
    iconStyle: <i className="fa-solid fa-calculator"></i>,
    content: [
        {
            title: 'الاصول التابتة',
            to: '/FixedAssetsPage',
            permission: 'FixedAssetsPage'
        },
         {
            title: 'الحسابات',
            to: '/AccountPage',
            permission: 'AccountPage'
        },
        {
            title: 'القيود المحاسبية',
            to: '/JournalEntryPage',
            permission: 'JournalEntryPage'
        },
        {
            title: 'الاستهلاك / الإهلاك',
            to: '/DepreciationPage',
            permission: 'DepreciationPage'
        },
         {
            title: 'الارصدة الافتتاحية',
            to: '/OpeningBalances',
            permission: 'OpeningBalances'
        },
        {
            title: 'التقارير',
            classsChange: 'mm-collapse',
            permission: 'ManageUser',
            iconStyle: <i className="fa-solid fa-chart-line"></i>,
            content: [
                {
                    title: 'الميزانية العمومية',
                    to: '/BalanceSheet',
                    permission: 'BalanceSheet'
                },
                {
                    title: 'قائمة الأرباح والخسائر',
                    to: '/ProfitLossPage',
                    permission: 'ProfitLossPage'
                },
                {
                    title: 'ميزان المراجعة',
                    to: '/TrialBalancePage',
                    permission: 'FixedAssetsPage'
                }
            ]
        }
    ]
},

    {
        title: 'إدارة المستخدمين',
        classsChange: 'mm-collapse',
        permission: 'FormValidation',

        iconStyle: <i className="fa-solid fa-users-rectangle"></i>,
        content: [
            {
                title: 'إضافة مستخدم',
                to: '/FormValidation',
                permission: 'FormValidation'
            },
            {
                title: 'بيانات المستخدمين',
                to: '/ManageUsers',
                permission: 'ManageUsers'
            }
        ]
    },
    // {
    //     title: 'إدارة التواريخ',
    //     classsChange: 'mm-collapse',
    //     iconStyle: <i class="fa-solid fa-calendar-xmark"></i>,
    //     content: [
    //         {
    //             title: 'كل التواريخ',
    //             to: '/DateLimitation',
    //             permission: 'AllOrderDateLimits'
    //         },
            
    //     ]
    // },
    {
        title: 'إعدادات',
        classsChange: 'mm-collapse',
        permission: 'ExpenseTypes',

        iconStyle: <i className="fa-solid fa-gear"></i>,
        content: [
           
           
           
            {
                title: 'انواع النفقات',
                to: '/ExpenseTypes',
                permission: 'ExpenseTypes'
            },
            {
                title: 'تصنيفات قطع الغيار',
                to: '/IntTypes',
                permission: 'IntTypes'
            },
            {
                title: 'الموديلات',
                to: '/Ingredients',
                permission: 'Ingredients'
            },
            {
                title: 'انواع السيارات',
               to: '/EmployeeStatus',
            permission: 'EmployeeStatus'
            },
            {
                title: 'نصنيفات الخدمات',
                to: '/StorageType',
                permission: 'StorageType'
            },
           
        ]
    }
];
